import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

const Footer = () => (
  <footer>
    <div className="row footer-content">
      <div className="container">
        <ul className="footer-nav">
          <li><a href="https://laxus.co/app/pc/info/about">ラクサスについて</a></li>
          <li><a href="https://laxus.co/app/pc/info/brandlist">取扱ブランド一覧</a></li>
          <li><a href="https://laxus.co/app/pc/bags">特集ページ</a></li>
          <li><a href="https://laxus.co/app/pc/brands">ブランドヒストリー</a></li>
          <li><a href="https://laxus.co/app/pc/info/howto">はじめてのご利用ガイド</a></li>
          <li><a href="https://laxus.co/app/pc/info/faq">よくある質問</a></li>
          <li><a href="https://laxus.co/app/pc/contact">お問い合わせ</a></li>
          <li><a href="https://laxus.co/app/pc/blog/guidelines">コミュニティガイドライン</a></li>
          <li><a rel="noreferrer" href="https://corp.laxus.co/recruit" target="_blank">採用情報</a></li>
          <li><a rel="noreferrer" href="https://corp.laxus.co/outline" target="_blank">運営会社</a></li>
          <li><a rel="noreferrer" href="https://corp.laxus.co/news#main_news_list" target="_blank">ニュース</a></li>
          <li><a rel="noreferrer" href="https://corp.laxus.co/en" target="_blank">English</a></li>
        </ul>
        <div className="recruit_kv_add">
          <h3><span>🥇</span>内閣総理大臣表彰 日本サービス大賞 優秀賞</h3>
          <h3><span>🥇</span>経済産業省 経産大臣賞 最優秀賞 *</h3>
          <h3><span>🥇</span>220万ダウンロード突破！</h3>
          <p className="add-komoji">*2017年10月ニッポン新事業創出大賞</p>
          {/* <p className="add-world">ラクサスはINDIVI、UNTITLED、TAKEO KIKUCHIなどを全国2000店舗以上を展開する総合アパレルメーカー株式会社ワールド（東証プライム市場上場：資本金60億円）のグループ会社です。</p>            */}
        </div>    
      </div>   
      <div className="association-list">
        <p>
          <div className="ass-logo-container">
            <div style={{width: "74px", margin: "0 auto"}}>
              <StaticImage alt="東証グロース上場" src="../images/logo_jpx.png" />
            </div>
          </div>
          <span>ラクサス・テクノロジーズ株式会社は、東京証券取引所 グロース市場に上場（証券コード：288A）しています。安心してご利用ください。</span>
        </p>
        <p>
          <div className="ass-logo-container"><StaticImage alt="日本流通自主管理協会(AACD)" src="../images/logo_aacd.png" /></div>
          <span>ラクサスは、偽物の流通防止・排除を目的とした日本流通自主管理協会（AACD）の正会員です。偽物の取り扱いはございませんのでご安心ください。</span>
        </p>
        <p>
          <div className="ass-logo-container"><StaticImage alt="シェアリングエコノミー協会" src="../images/logo_se.png" /></div>
          <span>シェアリングサービスを安心して利用できる環境作りと法的整備を推進するシェアリングエコノミー協会の正会員です。</span>
        </p>
        <p>
          <a className="ass-logo-container" href="https://privacymark.jp/">
            <div className="privacy-mark"><StaticImage alt="プライバシーマーク" src="../images/logo_privacy.png" /></div>
          </a>
          <span>プライバシーマークを取得しており、個人情報保護の体制が整備されています。お客様の情報を安全に管理しておりますのでご安心ください。</span>
        </p>  
      </div>
      <section className="bottom-area">
        <p className="laxus-logo">
          <a rel="noreferrer" href="https://laxus.co/app/pc/home"><img class="footer-logo-img" alt="Laxus" src="https://laxus.co/app/img/common/logo-black.png" /></a>
        </p>
        <div className="copyright">
          <a href="https://laxus.co/app/pc/info/privacy">プライバシーポリシー</a>
          <a href="https://laxus.co/app/pc/info/privacy_application">アプリケーション・プライバシーポリシー</a>
          <a href="https://laxus.co/app/pc/info/user">利用規約</a>
          <a href="https://laxus.co/app/pc/info/law">特定商取引法に基づく表記</a>
          <a href="https://laxus.co/app/pc/info/law_cash">資金決済法に基づく表示</a>
          <a href="https://laxus.co/app/pc/info/illegality">不正行為に対する当社の対応について</a>
        </div>
        <div className="bottom-line">
          <p>© 2015 - {new Date().getFullYear().toString()} Laxus Technologies, inc.</p>
          <div className="sns-icon">
            <a rel="noreferrer" href="https://www.youtube.com/@laxusbag" target="_blank"><img class="sns-icon-img" alt="Youtube" src="https://laxus.co/app/img/pc/common/snsyt2.png?1" /></a>         
            <a rel="noreferrer" href="https://www.facebook.com/laxus.jp/" target="_blank"><img class="sns-icon-img" alt="FaceBook" src="https://laxus.co/app/img/common/fb.png?1" /></a>
            <a rel="noreferrer" href="https://twitter.com/laxusco" target="_blank"><img class="sns-icon-img" alt="Twitter" src="https://laxus.co/app/img/common/twitter.png?1" /></a>
            <a rel="noreferrer" href="https://www.instagram.com/laxus__official/" target="_blank"><img class="sns-icon-img" alt="Instagram" src="https://laxus.co/app/img/common/insta.png?1" /></a>
          </div>
        </div>
      </section>
    </div>
  </footer>
)

export default Footer
